import { useRef } from "react";
import type { Title } from "@/mocks/titles";
import TitleCard from "@/components/feature/TitleCard";
import SectionHeading from "@/components/feature/SectionHeading";

interface LatestUpdatesProps {
  items: Title[];
}

export default function LatestUpdates({ items }: LatestUpdatesProps) {
  const scroller = useRef<HTMLDivElement>(null);

  const scrollBy = (dir: number) => {
    if (!scroller.current) return;
    scroller.current.scrollBy({ left: dir * 320, behavior: "smooth" });
  };

  return (
    <section>
      <div className="flex items-end justify-between gap-4 mb-5">
        <SectionHeading
          title="最新上线"
          subtitle="近期更新的影视内容，追新不错过"
          accentIcon="ri-flashlight-line"
        />
        <div className="hidden sm:flex items-center gap-2 mb-5">
          <button
            type="button"
            onClick={() => scrollBy(-1)}
            aria-label="向左滚动"
            className="w-9 h-9 rounded-full border border-background-300 bg-background-50 flex items-center justify-center text-foreground-700 hover:border-primary-400 hover:text-primary-500 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <button
            type="button"
            onClick={() => scrollBy(1)}
            aria-label="向右滚动"
            className="w-9 h-9 rounded-full border border-background-300 bg-background-50 flex items-center justify-center text-foreground-700 hover:border-primary-400 hover:text-primary-500 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>
      </div>

      <div
        ref={scroller}
        className="flex gap-4 overflow-x-auto no-scrollbar pb-2 -mx-4 px-4 md:mx-0 md:px-0"
      >
        {items.map((item) => (
          <TitleCard key={item.id} title={item} className="w-40 md:w-48 shrink-0" />
        ))}
      </div>
    </section>
  );
}